// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","443":"about"}[chunkId] + "." + {"177":"c496f339","443":"bf6e6151"}[chunkId] + ".js";
};